import type { PlacementId } from './api/api.autogenerated.js';

export type ExperimentName = string;

export type ExperimentPlacement = {
  enabled: boolean;
  placementId: PlacementId;
};

export type AmplitudeExperiments = {
  experiments: {
    [K in ExperimentName]?: ExperimentVariants;
  };

  payloads: {
    [K in ExperimentName]?: {
      placements?: Array<ExperimentPlacement>;
      [key: string]: unknown;
    };
  };
};

export enum ExperimentVariants {
  Control = 'control',
  Treatment = 'treatment',
  Treatment_1 = 'treatment_1',
  Treatment_2 = 'treatment_2',
  NoWallpaper = 'no_wallpaper'
}
